import { useQuery } from 'react-query'
import { AcoesModelo, AcoesProtocolo } from './_models'
import { obterAcoes, obterAcoesModelo } from './_requests'

const SEM_ACAO: AcoesProtocolo = { podeCriarRascunho: false, podeAprovar: false }
const SEM_ACAO_MODELO: AcoesModelo = { podeGerenciarModelo: false, podePublicarModelo: false }

/** Ações do usuário logado na empresa. Erro não derruba a tela: cai para "não pode". */
export const useProtocoloAcoes = (idEmpresa?: number) => {
  const { data, isLoading } = useQuery(
    ['protocolos-triagem', 'acoes', idEmpresa],
    () => obterAcoes(idEmpresa as number),
    { enabled: !!idEmpresa, retry: false }
  )
  return { acoes: data ?? SEM_ACAO, carregandoAcoes: isLoading }
}

export const useAcoesModelo = () => {
  const { data, isLoading } = useQuery(
    ['protocolos-triagem', 'acoes-modelo'],
    () => obterAcoesModelo(),
    { retry: false }
  )
  return { acoesModelo: data ?? SEM_ACAO_MODELO, carregandoAcoesModelo: isLoading }
}
